import * as React from 'react';
import classnames from 'classnames';

import InputRadio from 'components/inputs/input-radio/InputRadio';

import { __t, applyTranslations } from 'utils/language';

import './and-or.scss';

import type { AndOrOptions, AndOrSizes } from 'types';

applyTranslations(require('./and-or.i18n.json'));

type Props = {
  name: string,
  disabled?: boolean,
  selectedOption?: AndOrOptions,
  size?: AndOrSizes,
  onSetOption: (a: AndOrOptions) => void
};

const OPTIONS: Array<AndOrOptions> = ['and', 'or'];
const msgKey = 'and_or';

const AndOr = (
  {
    name,
    disabled = false,
    selectedOption = 'none',
    size = 'normal',
    onSetOption
  }: Props
): JSX.Element => {
  const [option, setOption] = React.useState(selectedOption);

  React.useEffect(() => {
    setOption(option);
  });

  const handleSetOption = (item: AndOrOptions): void => {
    setOption(item);
    onSetOption(item);
  };

  const containerClasses = classnames('and-or', {
    [`and-or--size-${size}`]: Boolean(size)
  });

  return (
    <div className={containerClasses}>
      {
        OPTIONS.map(item => (
          <InputRadio
            id={`and-or-${name}-${item}`}
            key={`and-or-${item}`}
            name={`and-or-${name}`}
            disabled={disabled}
            label={__t(`${msgKey}.labels.${item}`)}
            value={item}
            checked={item === option}
            onChange={() => handleSetOption(item)}
          />
        ))
      }
    </div>
  );
};

export default AndOr;
